// Currency utility functions
export const formatCurrency = (amount) => {
  if (amount === null || amount === undefined) return '₹0'

  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount

  if (isNaN(numAmount)) return '₹0'

  // Format with Indian number system (lakhs, crores)
  if (numAmount >= 10000000) { // 1 crore
    return `₹${(numAmount / 10000000).toFixed(2)}Cr`
  } else if (numAmount >= 100000) { // 1 lakh
    return `₹${(numAmount / 100000).toFixed(2)}L`
  } else if (numAmount >= 1000) { // 1 thousand
    return `₹${(numAmount / 1000).toFixed(1)}K`
  } else {
    return `₹${numAmount.toFixed(0)}`
  }
}

export const formatFundSizeToCrores = (fundSize, decimals = null) => {
  if (!fundSize && fundSize !== 0) return '-';

  const numSize = typeof fundSize === 'string' ? parseFloat(fundSize) : fundSize;

  if (isNaN(numSize) || numSize === 0) return '-';

  // Convert to crores (divide by 1 crore = 10000000)
  const crores = numSize / 10000000;

  let formatted;
  if (decimals !== null) {
    formatted = crores.toFixed(decimals);
  } else {
    // Format: if whole number, show without decimals, otherwise show 2 decimal places
    formatted = crores % 1 === 0
      ? crores.toString()
      : crores.toFixed(2);
  }

  return `₹ ${formatted}`;
  // return `${formatted} cr`;
};

export const formatCurrencyDetailed = (amount) => {
  if (amount === null || amount === undefined) return '₹0'

  const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount

  if (isNaN(numAmount)) return '₹0'

  // Format with commas for thousands
  return `₹${numAmount.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

export const formatPercentage = (percentage) => {
  if (percentage === null || percentage === undefined) return '0.00%'

  const numPercentage = typeof percentage === 'string' ? parseFloat(percentage) : percentage

  if (isNaN(numPercentage)) return '0.00%'

  const sign = numPercentage >= 0 ? '+' : ''
  return `${sign}${numPercentage.toFixed(2)}%`
}

/**
 * Format a numeric string with Indian numbering system commas
 * Pattern: First 3 digits from right, then groups of 2 digits
 * Examples: 5000 → 5,000 | 100000 → 1,00,000 | 10000000 → 1,00,00,000
 * @param {string} value - Input value (can contain numbers and commas)
 * @returns {string} Formatted string with Indian numbering system commas
 */
export const formatIndianNumber = (value) => {
  if (value === null || value === undefined || value === '') return ''

  const strValue = String(value)

  // Remove all non-numeric characters
  const numericValue = strValue.replace(/[^\d]/g, '')

  // If no numeric characters, return empty string
  if (!numericValue) return ''

  // Handle leading zeros - remove them except for single zero
  const cleanedValue = numericValue.replace(/^0+/, '') || '0'
  if (cleanedValue === '0' && numericValue.length > 1) {
    return '0'
  }

  // Convert to number and use Intl.NumberFormat for Indian numbering
  const num = parseInt(cleanedValue, 10)
  if (isNaN(num)) return ''

  return new Intl.NumberFormat('en-IN', {
    maximumFractionDigits: 0
  }).format(num)
}
/**
 * Parse Indian formatted number string to clean numeric string
 * Removes all commas and returns only digits
 * @param {string} value - Formatted string with commas
 * @returns {string} Clean numeric string without commas
 */
export const parseIndianNumber = (value) => {
  if (value === null || value === undefined || value === '') return ''

  const strValue = String(value)

  // Remove all non-numeric characters
  return strValue.replace(/[^\d]/g, '')
}

/**
 * Format a number with Indian numbering system and up to 2 decimal places
 * @param {number|string} value - Input value
 * @returns {string} Formatted string
 */
export const formatIndianNumberWithDecimals = (value) => {
  if (value === null || value === undefined || value === '') return ''

  const num = typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value
  if (isNaN(num)) return ''

  return new Intl.NumberFormat('en-IN', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2
  }).format(num)
}

